import React from 'react';
const LeftArrowIcon = ({ fill = '#424242', className }: { fill?: any; className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill={fill} className={className}>
    <g clipPath="url(#a)">
      <path fill={fill} d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2Z" />
    </g>
    <defs>
      {/* <clipPath id="a"> */}
      <path fill={fill} d="M0 0h24v24H0z" />
      {/* </clipPath> */}
    </defs>
  </svg>
);
export default LeftArrowIcon;
